import { render, staticRenderFns } from "./TableRejectedVoip.vue?vue&type=template&id=651f1954&scoped=true&"
import script from "./TableRejectedVoip.vue?vue&type=script&lang=js&"
export * from "./TableRejectedVoip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f1954",
  null
  
)

export default component.exports